



































import { Component, Prop, Vue } from 'vue-property-decorator';
import imagePreview from '@/components/Reusable/imagePreview.vue';
import { DocumentKindParams } from '@/store/interfaces/document';
import { documentsDrafts } from '@/store/interfaces/drafts';

@Component({ components: { imagePreview, }, })
export default class DocumentsInboundForm extends Vue {
  @Prop({
    required: true,
    type: Array,
  })
  documentKind!: DocumentKindParams[];

  @Prop({
    required: true,
    type: Array,
  })
  documents!: documentsDrafts[];

  @Prop({
    required: true,
    type: String,
  })
  title!: string;

  findKindOfDocument(kind: string): string {
    const documentKind = this.documentKind.find((cm) => cm.id === kind);
    return documentKind ? documentKind.name : 'Desconocido';
  }
}
